import { Card, CardContent, Grid2 } from '@mui/material';
import React from 'react';

import ContentLoader from '@components/ContentLoader';
import { DrilldownItemCte } from '@components/DrilldownItem';
import type { ItemType } from '@components/DrilldownItem/DrilldownItem';

interface Metadata {
  title: string;
  value?: string | null;
  editOptions?: {
    name: string;
    type?: ItemType;
  };
}

interface MetadataCardProps {
  loading: boolean;
  data: Metadata[];
}

const MetadataCard = ({
  data,
  loading,
}: React.PropsWithChildren<MetadataCardProps>) => {
  return (
    <Card>
      <CardContent>
        <ContentLoader loading={loading}>
          <Grid2 container spacing={1}>
            {data.map(({ title, value, editOptions }) => (
              <Grid2 size={{ xs: 12 }} key={title}>
                <DrilldownItemCte
                  name={editOptions?.name}
                  label={title}
                  value={value}
                  readOnly={!editOptions}
                  type={editOptions?.type}
                />
              </Grid2>
            ))}
          </Grid2>
        </ContentLoader>
      </CardContent>
    </Card>
  );
};

export default MetadataCard;
export type { Metadata, MetadataCardProps };
